"use strict";
import ReactUtils from "../../react_utils";
import _ from "../../util/underscore_extensions";
import format from "../../formatters/general";
var bem = ReactUtils.makeBem("carrier-payable-chooser");
export default React.createClass({
  render: function() {
    const validCarrierPayables = this.props.carrierPayables.filter((payable) => {
      return payable.tms_carrier_id == this.props.carrier.id;
    });
    if (this.props.allowsEditing) {
      if (validCarrierPayables.length == 0) {
        return this.renderEditableEmpty();
      } else {
        return this.renderDropdown(validCarrierPayables);
      }
    } else {
      if (this.props.currentCarrierPayableId) {
        return this.renderDropdown(validCarrierPayables);
      } else {
        return this.renderUneditableNone();
      }
    }
  },
  renderEditableEmpty: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem() }, /* @__PURE__ */ React.createElement("i", { className: bem("__warning-icon") + " fi-alert" }), /* @__PURE__ */ React.createElement("div", { className: bem("__warning-text") }, "Carrier payable not found: Carrier payable will need to be created in TMS to proceed."));
  },
  renderUneditableNone: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem() }, /* @__PURE__ */ React.createElement("div", { className: bem("__warning-text") }, "No linked payable"));
  },
  renderDropdown: function(validCarrierPayables) {
    const placeholderDefaultVal = "placeholderDefaultVal";
    const notaVal = "notaVal";
    const currentVal = this.props.currentCarrierPayableId || placeholderDefaultVal;
    const options = validCarrierPayables.map(this.payableToOption);
    return /* @__PURE__ */ React.createElement("div", { className: bem() }, /* @__PURE__ */ React.createElement(
      "select",
      {
        defaultValue: currentVal,
        onChange: this.props.onChange,
        disabled: !this.props.allowsEditing
      },
      /* @__PURE__ */ React.createElement("option", { value: placeholderDefaultVal, disabled: true }, "Select a carrier payable for this invoice"),
      options,
      /* @__PURE__ */ React.createElement("option", { value: notaVal }, "None of the above")
    ));
  },
  payableToOption: function(payable) {
    let title = payable.external_id ? `<Carrier payable #${payable.external_id}>` : `<Carrier payable>`;
    if (this.props.carrierInvoice != null && payable.carrier_invoice_id && payable.carrier_invoice_id != this.props.carrierInvoice.id) {
      title = `[LINKED] ${title}`;
    }
    const totalStr = `Total amount ${format.currency(this.total(payable))}`;
    const status = payable.status ? `(${payable.status})` : "";
    const content = `${title} ${totalStr} ${status}`;
    return /* @__PURE__ */ React.createElement("option", { key: payable.id, value: payable.id }, content);
  },
  total: function(carrierPayable) {
    return _.chain(this.props.lineItems).filter((li) => li.tms_carrier_payable_id == carrierPayable.id).map((li) => parseFloat(li.total)).compact().sum().value();
  }
});
